import React from 'react';

import styles from './Alert.module.scss';

interface Props {
  title: string;
  body: string;
}

export const Alert: React.FC<Props> = ({ title, body }) => {
  return (
    <div className={styles.Outer} data-testid="alert">
      <div>
        <h3 data-testid="alert-title">{title}</h3>
        <p data-testid="alert-body">{body}</p>
      </div>
    </div>
  );
};
